<template>
  <div class="publications-page">
    <NavigationBar />
    
    <div class="main-content">
      <div class="header-section">
        <h1 class="page-title">Publications</h1>
      </div>

      <!-- Books Section -->
      <section class="publications-section">
        <h2 class="section-title">Books</h2>
        <div class="books-grid">
          <div v-for="book in books" :key="book.id" class="book-card">
            <div class="book-image">
              <img :src="book.image" :alt="book.title" />
            </div>
            <div class="book-content">
              <h3 class="book-title">{{ book.title }}</h3>
              <p class="book-publisher">{{ book.publisher }}</p>
              <p class="book-year">{{ book.year }}</p>
              <p class="book-pages" v-if="book.pages">{{ book.pages }}</p>
              <p class="book-description" v-if="book.description">{{ book.description }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Articles Section -->
      <section class="publications-section">
        <h2 class="section-title">Articles</h2>
        <div class="articles-list">
          <div v-for="article in articles" :key="article.id" class="article-card">
            <div class="article-year">{{ article.year }}</div>
            <div class="article-content">
              <h3 class="article-title">{{ article.title }}</h3>
              <p class="article-journal">{{ article.journal }}</p>
              <p class="article-details" v-if="article.details">{{ article.details }}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import NavigationBar from './NavigationBar.vue';

export default {
  name: 'UserPublications',
  components: { 
    NavigationBar
  },
  data() {
    return {
      books: [
        {
          id: 1,
          year: 2013,
          title: "Aristotle's Concept of Chance - Accidents, Cause, Necessity and Determinism",
          publisher: "State University of New York Press (Paperback edition)",
          image: "/images/book-placeholder.svg",
          description: "Paperback edition of the comprehensive analysis of chance in Aristotelian philosophy."
        },
        {
          id: 2,
          year: 2012,
          title: "Aristotle's Concept of Chance - Accidents, Cause, Necessity and Determinism",
          publisher: "State University of New York Press, New York",
          pages: "xiv-469pp",
          image: "/images/book-placeholder.svg",
          description: "A comprehensive examination of Aristotle's understanding of chance, accidents, causation, necessity and determinism."
        },
        {
          id: 3,
          year: 1999,
          title: "Dio e Contemplazione in Aristotele, Il Fondamento Metafisico dell' 'Etica Nicomachea'",
          publisher: "Vita e Pensiero, Milan",
          pages: "XXVI-223pp",
          image: "/images/book-placeholder.svg",
          description: "Italian translation with introduction by Giovanni Reale, exploring the metaphysical foundations of Aristotelian ethics."
        },
        {
          id: 4,
          year: 1997,
          title: "The Evolution of the Concept of Chance in the Physics and Ethics of Aristotle, A Commentary on Physics B 4-6",
          publisher: "Acco, Amersfoort",
          pages: "328pp",
          image: "/images/book-placeholder.svg",
          description: "Detailed commentary on key passages in Aristotle's Physics examining the development of chance theory."
        },
        {
          id: 5,
          year: 1982,
          title: "Gott und Θεωρία bei Aristoteles, Die metaphysische Grundlage der Nikomachischen Ethik",
          publisher: "Peter Lang, Frankfurt a/M - Bern",
          pages: "241pp",
          image: "/images/book-placeholder.svg",
          description: "Foundational work examining God and contemplation in Aristotle as the metaphysical basis of the Nicomachean Ethics."
        }
      ],
      articles: [
        {
          id: 1,
          year: 2021,
          title: "Neoplatonism confronted by Aristotelianism in Western Christianity",
          journal: "Héritages platoniciens et aristotéliciens dans l'Orient et l'Occident (IIe-XVIe siècles)",
          details: "Wiesbaden, Reichert Verlag (Scrinium Friburgense Band 54), 211-223"
        },
        {
          id: 2,
          year: 2020,
          title: "The Theology of Aristotle's Ethics and Politics",
          journal: "2400 Years of Thinking with Aristotle",
          details: "Ed. Mircea Dumitru, Cristian Iftode, and Savu Totu, Editura Universitãtü din Buchuresti, 29-45"
        },
        {
          id: 3,
          year: 2019,
          title: "What is the Meaning of Ethics for Aristotle?",
          journal: "Aristotle, 2400 Years, Proceedings of the World Congress May 23-28, 2016",
          details: "Ed. Demetra Sfendoni-Mentzou, Thessaloniki, 227-232"
        },
        {
          id: 4,
          year: 2018,
          title: "God's Pleasure and Man's Pleasure according to St. Thomas Aquinas",
          journal: "Divus Thomas 121, 3",
          details: "178-188. Proceedings of the 6th International Conference of the International Society of Thomas Aquinas (SITA)"
        },
        {
          id: 5,
          year: 2018,
          title: "Plato's Concept of Chance",
          journal: "Платоновские исследования – Вып. 9 (2018 / 2)",
          details: "56-71. Proceedings of the congress of the International Plato Society in St. Petersburg"
        },
        {
          id: 6,
          year: 2018,
          title: "A Reinterpretation of Aristotle's metaphysics",
          journal: "Philosophia 48",
          details: "152-164"
        },
        {
          id: 7,
          year: 2018,
          title: "Fundamentos físicos y metafísicos de la ética para Aristóteles",
          journal: "Arete, Revista de Filosofía, 30",
          details: "7-21"
        },
        {
          id: 8,
          year: 2018,
          title: "The Unrealism of Aristotle's Metaphysics?",
          journal: "Proceedings of the XXIII World Congress of Philosophy, Vol. II, Section II Classical Greek Philosophy",
          details: "95-99, ed. Konstantinos Boudouris"
        },
        {
          id: 9,
          year: 2018,
          title: "Aristotle on the Divine",
          journal: "предизвикателството Аристотел (Aristotle: The Challenge)",
          details: "23-36. Sofia: University Press 'St. Kliment Ohridsky'"
        },
        {
          id: 10,
          year: 2018,
          title: "Aristotle's Views on Chance and their Contemporary Relevance",
          journal: "Schole 12",
          details: "7-27. Proceedings of the International Conference on Aristotle held in Novosibirsk"
        },
        {
          id: 11,
          year: 2017,
          title: "Физические и метафизические основания этики у Аристотеля",
          journal: "Verbum 19",
          details: "9-23. Proceedings of the International Conference on Aristotle's Ethics, St. Petersburg"
        },
        {
          id: 12,
          year: 2017,
          title: "Aristotle's Three Teleologies",
          journal: "The Legacies of Aristotle as Constitutive Element of European Rationality",
          details: "175-186. Ed. Valery V. Petroff. Moscow, Aquilo Press"
        },
        {
          id: 13,
          year: 2017,
          title: "The Superiority of Science to Ethics according to Aristotle and its Influence on Contemporary Science and Culture",
          journal: "The Influence of Hellenism on Contemporary Science, Culture and Education",
          details: "155-168, ed. T.P. Minchenko, STT, Tomsk; reprinted 21-28, London, Red Square Scientific"
        },
        {
          id: 14,
          year: 2017,
          title: "Aristotle on Teleology",
          journal: "Key Themes and Figures in Ancient and Medieval Philosophy (Gale Researcher Internet Library)",
          details: "Ed. Brendan Sweetman. Detroit, MI: Gale/Cengage, 4898 words"
        },
        {
          id: 15,
          year: 2017,
          title: "Aristotle Doctrine of the Mean",
          journal: "Key Themes and Figures in Ancient and Medieval Philosophy (Gale Researcher Internet Library)",
          details: "Ed. Brendan Sweetman. Detroit, MI: Gale/Cengage, 2061 words"
        },
        {
          id: 16,
          year: 2017,
          title: "The Theme of Eudaimonia in Aristotle",
          journal: "Key Themes and Figures in Ancient and Medieval Philosophy (Gale Researcher Internet Library)",
          details: "Ed. Brendan Sweetman. Detroit, MI: Gale/Cengage, 3616 words"
        },
        {
          id: 17,
          year: 2017,
          title: "Za udovolstviyata ot antichnata philosophiya (For the Pleasures of Ancient Philosophy)",
          journal: "Literaturen Vestnik [Literary newspaper]. Sofia, Literaturen Vestnik Foundation 26",
          details: "nr. 3 (25-31 Jan. 2017), p. 5"
        },
        {
          id: 18,
          year: 2016,
          title: "Congratulations! Congratulations to Fr. Leo Elders SVD on the occasion of his ninetieth birthday",
          journal: "Libenter Praeceptorum Laudes Celebrarem, Stories and Reflections in Honor of Leo J. Elders S.V.D.",
          details: "114-120, ed. Jörgen Vijgen, Kerkrade"
        },
        {
          id: 19,
          year: 2014,
          title: "The Fate of Providence and Plato's World Soul in Aristotle",
          journal: "Fate, Providence and Moral Responsibility in Ancient, Medieval and Early Modern Thought",
          details: "59-74, Studies in Honour of Carlos Steel, ed. Pieter d'Hoine and Gerd Van Riel, Leuven University Press"
        },
        {
          id: 20,
          year: 2014,
          title: "Aristotle's Concept of Chance and its Importance for Human Responsibility",
          journal: "Sobre Responsabilidade",
          details: "7-35, ed. Denis Coitinho and João Hobuss, Pelotas. Proceedings of the III Congresso Internacional de Filosofía Moral e Política"
        },
        {
          id: 21,
          year: 2012,
          title: "Aristotle's Metaphysics as Mysticism",
          journal: "Tattva 8",
          details: "99-119"
        },
        {
          id: 22,
          year: 2012,
          title: "A Revised Interpretation of the Mediaeval Reception of Aristotle's Metaphysics",
          journal: "Universality of Reason. Plurality of Philosophies in the Middle Ages. XII Congresso Internazionale di Filosofia Medievale",
          details: "1197-1201, Vol. II.2. Communicazioni. Latina. Ed. Alessandro Musco et al., Palermo, Officina di Studi Medievali"
        },
        {
          id: 23,
          year: 2011,
          title: "Newman's Criticism of Aristotle's Thesis that Science is superior to Ethics",
          journal: "Angelicum 88",
          details: "465-479"
        },
        {
          id: 24,
          year: 2006,
          title: "Evolution de la pensée aristotélicienne du plaisir",
          journal: "Le Plaisir, Réflexions antiques, approches modernes",
          details: "87-99, ed. René Lefebvre and Laurence Villard, Presses Universitaires de Rouen"
        },
        {
          id: 25,
          year: 2005,
          title: "The Metaphysical Presuppositions of Freedom",
          journal: "Proceedings of the International Congress on Christian Humanism in the Third Millennium: The Perspective of Thomas Aquinas",
          details: "Vol. II, 287-295, Vatican City"
        },
        {
          id: 26,
          year: 2005,
          title: "Necessity and Chance: Aristotle's Criticism of the Presocratics",
          journal: "Tyche-Ananke, Hasard et nécessité dans la philosophie grecque",
          details: "92-110, Athens, Academy of Athens"
        },
        {
          id: 27,
          year: 2004,
          title: "Ethical and Metaphysical Foundations of the Rejection of Determinism by Aquinas",
          journal: "Verbum, Acta Neolatina (Budapest), VI (2004, 2)",
          details: "315-324"
        },
        {
          id: 28,
          year: 2004,
          title: "The Meaning of Nous in the Ethics of Aristotle",
          journal: "Bollettino Filosofico (Calabria), 20",
          details: "25-39"
        },
        {
          id: 29,
          year: 2004,
          title: "Happiness, Human Nature and Teleology in Ancient and Mediaeval Philosophy",
          journal: "Intellect et Imagination dans la Philosophie Médiévale, Actes du XIe Congrès International de Philosophie Médiévale",
          details: "349-355, vol. IV, Mediaevalia. Textos e Estudos 23, Porto"
        },
        {
          id: 30,
          year: 2003,
          title: "Aristotle's Refutation of Determinism (Met. E3)",
          journal: "Indubitanter ad Veritatem, Studies offered to Leo J. Elders (Festschrift)",
          details: "133-150, ed. J. Vijgen, Budel"
        },
        {
          id: 31,
          year: 2002,
          title: "God as a Foundation of Plato's and of Aristotle's Ethics",
          journal: "New Images of Plato, Dialogues on the Idea of the Good",
          details: "395-406, ed. Giovanni Reale and Samuel Scolnicov, Academia Verlag (Germany)"
        },
        {
          id: 32,
          year: 2001,
          title: "Is it a Perfect World? Spinoza and the Principle of Perfection",
          journal: "Liber Amicorum Raphael de Smedt, Vol. IV, Litterarum Historia, Miscellanea Neerlandica 26",
          details: "161-178, ed. A. Tourneux, Leuven"
        },
        {
          id: 33,
          year: 1999,
          title: "Die Entdeckung Gottes",
          journal: "Kirchliche Umschau 4/5",
          details: "11-13"
        },
        {
          id: 34,
          year: 1998,
          title: "De wijsheid van het christendom: een repliek op Nietzsche",
          journal: "Communio 23",
          details: "356-364"
        },
        {
          id: 35,
          year: 1998,
          title: "De Verhouding van Wetenschap en Ethiek bij Aristoteles",
          journal: "Wijsgerig Perspectief 39",
          details: "22-27"
        },
        {
          id: 36,
          year: 1997,
          title: "De Toekomst van het Christendom",
          journal: "Quanta Cura 7(1997,4)",
          details: "3-9"
        },
        {
          id: 37,
          year: 1997,
          title: "Nuopolis ir Pakilimas",
          journal: "Dienovidis (Lithuania), 46(1997) and 47(1997)",
          details: "p.15 and pp. 14-15"
        },
        {
          id: 38,
          year: 1996,
          title: "De hoeksteen van de samenleving",
          journal: "Zaken die God raken 7(1996,1)",
          details: "13-16 (joint author R.G.L.M. Mutsaerts)"
        },
        {
          id: 39,
          year: 1995,
          title: "Das betrachtende Leben (bios theoretikos) bei Platon und Aristoteles: ein kritischer Ansatz",
          journal: "Neue Zeitschrift für Systematische Theologie und Religions-Philosophie, 37",
          details: "20-40"
        },
        {
          id: 40,
          year: 1995,
          title: "The Concept of Substance and Life presupposed by Christianity",
          journal: "Christian Humanism, International Perspectives",
          details: "105-117, ed. Richard P. Francis and Jane E. Francis, New York (republished)"
        },
        {
          id: 41,
          year: 1995,
          title: "The Historical Origin of the Division between Ethics and Science - the Conflict between Aristotle and Christianity",
          journal: "Christian Humanism, International Perspectives",
          details: "187-199, ed. Richard P. Francis and Jane E. Francis, New York (republished)"
        },
        {
          id: 42,
          year: 1993,
          title: "De invloed van het begrip toeval bij Aristoteles op het godsbewijs vanuit de orde in het heelal",
          journal: "Gehelen en Fragmenten, De vele gezichten van de filosofie, Acta van de 14e Filosofiedag te Leuven",
          details: "99-102, ed. Bart Raymaekers, Leuven"
        },
        {
          id: 43,
          year: 1986,
          title: "The Concept of Substance and Life presupposed by Christianity",
          journal: "El Humanismo y la Metafísica Cristiana en la Actualidad, Vol. II, Segundo Congreso Mundial de Filosofia Cristiana",
          details: "539-553, Monterrey"
        },
        {
          id: 44,
          year: 1986,
          title: "The Historical Origin of the Division between Ethics and Science - the Conflict between Aristotle and Christianity",
          journal: "El Humanismo y la Metafísica Cristiana en la Actualidad, Vol. V, Segundo Congreso Mundial de Filosofia Cristiana",
          details: "217-230, Monterrey"
        },
        {
          id: 45,
          year: 1985,
          title: "Substance, Nature and Time: A Criticism of Aristotle",
          journal: "Nymegen Studies in the Philosophy of Nature and its Sciences 4, Part II",
          details: "69-84, ed. P. Kroes"
        },
        {
          id: 46,
          year: 1985,
          title: "Dialectic, Language and Reality in Aristotle",
          journal: "Language and Reality in Greek Philosophy",
          details: "182-193, Athens"
        },
        {
          id: 47,
          year: 1984,
          title: "El sentido de la felicidad de la vida perfecta (bios teleios) en la Etica de Aristóteles",
          journal: "Ethos (Buenos Aires) 10-11 (1982-3)",
          details: "39-54 (publ. 1984)"
        },
        {
          id: 48,
          year: 1984,
          title: "The Ethics of Democritus and Aristotle",
          journal: "Proceedings of the First International Congress on Democritus, Xanthi 6-9 October 1983",
          details: "371-385, Xanthi"
        },
        {
          id: 49,
          year: 1983,
          title: "The Love of God in Aristotle's Ethics",
          journal: "Neue Zeitschrift für Systematische Theologie und Religionsphilosophie, 25",
          details: "126-137"
        },
        {
          id: 50,
          year: 1983,
          title: "De historische scheiding tussen ethiek en wetenschap",
          journal: "Nymegen Studies in the Philosophy of Nature and its Sciences, 3",
          details: "121-143, ed. G. Debrock, P. Kroes and P. Scheurer"
        },
        {
          id: 51,
          year: 1982,
          title: "La contemplation (θεωρία) humaine selon Aristote",
          journal: "Revue Philosophique de Louvain 80",
          details: "387-413"
        },
        {
          id: 52,
          year: 1974,
          title: "Johannes Grammaticus Philoponus Alexandrinus, In Aristotelis De Anima, Proemion, translated from the Greek",
          journal: "Bulletin de Philosophie Médiévale 16-17 (1974-5)",
          details: "62-85"
        }
      ]
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,400;0,600;1,400&family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&display=swap');

.publications-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f6f0 0%, #e8e2d5 100%);
  font-family: 'Crimson Text', serif;
  color: #2c3e50;
}

.main-content {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 120px; /* Account for navigation */
}

.header-section {
  text-align: center;
  margin-bottom: 4rem;
  padding: 2rem 0;
  border-bottom: 3px solid #8b7355;
}

.page-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 3.5rem;
  font-weight: 600;
  color: #8b7355;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.1);
}

.page-subtitle {
  font-size: 1.3rem;
  color: #5d4e75;
  font-style: italic;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.publications-section {
  margin-bottom: 5rem;
}

.section-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 2.5rem;
  color: #8b7355;
  margin-bottom: 2.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #d4af37;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 60px;
  height: 2px;
  background: #5d4e75;
}

/* Books Section */
.books-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2.5rem;
  margin-bottom: 3rem;
}

.book-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e8e2d5;
}

.book-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 32px rgba(0,0,0,0.2);
}

.book-image {
  height: 250px;
  background: linear-gradient(45deg, #8b7355, #5d4e75);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.book-image::before {
  content: '📚';
  font-size: 4rem;
  opacity: 0.3;
  position: absolute;
}

.book-image img {
  width: 160px;
  height: 220px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.book-content {
  padding: 1.8rem;
}

.book-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 1rem;
  line-height: 1.4;
}

.book-publisher {
  font-weight: 600;
  color: #8b7355;
  margin-bottom: 0.5rem;
}

.book-year {
  font-size: 1.1rem;
  font-weight: 600;
  color: #d4af37;
  margin-bottom: 0.5rem;
}

.book-pages {
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 1rem;
  font-style: italic;
}

.book-description {
  color: #5a5a5a;
  line-height: 1.6;
  font-size: 0.95rem;
}

/* Articles Section */
.articles-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.article-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 1.8rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-left: 4px solid #d4af37;
  display: flex;
  gap: 2rem;
  transition: all 0.3s ease;
}

.article-card:hover {
  transform: translateX(8px);
  box-shadow: 0 6px 18px rgba(0,0,0,0.15);
  border-left-color: #8b7355;
}

.article-year {
  flex-shrink: 0;
  width: 80px;
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.3rem;
  font-weight: 600;
  color: #8b7355;
  text-align: center;
  padding: 0.5rem;
  background: #f8f6f0;
  border-radius: 6px;
  height: fit-content;
}

.article-content {
  flex: 1;
}

.article-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.8rem;
  line-height: 1.4;
}

.article-journal {
  font-weight: 600;
  color: #5d4e75;
  margin-bottom: 0.5rem;
  font-style: italic;
}

.article-details {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
}

/* Responsive Design */
@media (max-width: 768px) {
  .main-content {
    padding: 1rem;
    padding-top: 100px;
  }
  
  .page-title {
    font-size: 2.5rem;
  }
  
  .page-subtitle {
    font-size: 1.1rem;
  }
  
  .books-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .article-card {
    flex-direction: column;
    gap: 1rem;
  }
  
  .article-year {
    width: 100%;
    text-align: left;
  }
  
  .book-image {
    height: 200px;
  }
  
  .book-image img {
    width: 120px;
    height: 180px;
  }
}

@media (max-width: 480px) {
  .header-section {
    margin-bottom: 2rem;
  }
  
  .page-title {
    font-size: 2rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .book-content {
    padding: 1.2rem;
  }
  
  .article-card {
    padding: 1.2rem;
  }
}

/* Print Styles */
@media print {
  .publications-page {
    background: white;
  }
  
  .book-card, .article-card {
    box-shadow: none;
    border: 1px solid #ccc;
    break-inside: avoid;
  }
  
  .book-card:hover, .article-card:hover {
    transform: none;
  }
}
</style>

